import React from "react";
import { ResponsiveContainer } from "recharts";

/**
 * Animated chart frame (use inside analytics panels).
 * @param {{ height?: number, className?: string, children: React.ReactElement }} props
 */
export default function PortalChart({ height = 280, className = "", children }) {
  return (
    <div
      className={`pca-chart pca-chart--animate${className ? ` ${className}` : ""}`}
      style={{ width: "100%", height }}
    >
      <ResponsiveContainer width="100%" height="100%">
        {children}
      </ResponsiveContainer>
    </div>
  );
}
